// extracted by mini-css-extract-plugin
export default {"root":"IconJamIconsOutlineLogosFacebo_root__FRQEW","vector":"IconJamIconsOutlineLogosFacebo_vector__7ISDS","icon":"IconJamIconsOutlineLogosFacebo_icon__xVpUO"};